import { lazy } from "react";
import { Outlet, type RouteObject } from "react-router-dom";
import { ROUTES } from "./constants";
import { protectedRoute } from "./helpers";

const AdminLayout = lazy(
	() => import("../einstein/components/admin/layout/AdminLayout"),
);
const AdminPage = lazy(() => import("../einstein/components/admin/AdminPage"));
const AdminHowToPage = lazy(
	() => import("../einstein/components/admin/howTo/HowToPage"),
);
const MethodologyFormNew = lazy(
	() => import("../einstein/components/admin/methodologies/MethodologyFormNew"),
);
const UsersPage = lazy(() => import("../einstein/components/admin/users"));
const NotFound = lazy(
	() => import("../einstein/components/common/errors/NotFound"),
);

export const adminRoute: RouteObject = {
	path: ROUTES.ADMIN,
	element: protectedRoute(
		<AdminLayout>
			<Outlet />
		</AdminLayout>,
	),
	children: [
		{
			path: "",
			element: <AdminPage />,
		},
		{
			path: "users",
			element: <UsersPage />,
		},
		{
			path: "methodologies",
			element: <MethodologyFormNew />,
		},
		{
			path: "how-to",
			element: <AdminHowToPage />,
		},
		{
			path: "*",
			element: <NotFound />,
		},
	],
};
